import { FetchHandler } from 'json-api-hooks';

import BadgeModal from '../modals/BadgeModal';

import useModalDispatch from './useModalDispatch';

const useFetchSuccessHandler = (): FetchHandler<unknown> => {
  const dispatchBadgeModal = useModalDispatch(BadgeModal, { size: 'sm' });

  return ({ response }) => {
    const badgeId = response.headers.get('X-Badge-Id');

    if (badgeId) {
      dispatchBadgeModal({ id: badgeId }, response.headers.get('Location'));
    }
  };
};

export default useFetchSuccessHandler;
